import React from "react";
import { FiThermometer, FiDroplet, FiWind, FiActivity } from "react-icons/fi";
import { SectionHeader } from "../../../components/Shared";
import { MiniBar } from "./facilityHelpers";

const EnvironmentPanel = ({ d }) => (
  <div>
    <SectionHeader title="Environmental Monitoring – Zone Detail" />
    <div className="fm-env-grid">
      {d.zones.map(z => (
        <div key={z.id} className="fm-env-card">
          <div className="fm-env-card-header">
            <span className="fm-env-card-name">{z.name}</span>
            <span className={`fm-badge fm-badge-${z.status.toLowerCase()}`}>{z.status}</span>
          </div>
          <div className="fm-env-metrics">
            <div className="fm-env-metric">
              <div className="fm-env-metric-icon" style={{ color: "#ef4444" }}><FiThermometer size={16}/></div>
              <div>
                <div className="fm-env-metric-val">{z.temp}°C</div>
                <div className="fm-env-metric-lbl">Temperature</div>
              </div>
              <MiniBar value={z.temp} max={45} color={z.temp > 30 ? "#ef4444" : z.temp > 26 ? "#f59e0b" : "#10b981"} />
            </div>
            <div className="fm-env-metric">
              <div className="fm-env-metric-icon" style={{ color: "#3b82f6" }}><FiDroplet size={16}/></div>
              <div>
                <div className="fm-env-metric-val">{z.humidity}%</div>
                <div className="fm-env-metric-lbl">Humidity</div>
              </div>
              <MiniBar value={z.humidity} max={100} color={z.humidity > 70 ? "#ef4444" : z.humidity > 60 ? "#f59e0b" : "#10b981"} />
            </div>
            <div className="fm-env-metric">
              <div className="fm-env-metric-icon" style={{ color: "#8b5cf6" }}><FiWind size={16}/></div>
              <div>
                <div className="fm-env-metric-val">{z.co2} ppm</div>
                <div className="fm-env-metric-lbl">CO₂</div>
              </div>
              <MiniBar value={z.co2} max={1500} color={z.co2 > 1000 ? "#ef4444" : z.co2 > 800 ? "#f59e0b" : "#10b981"} />
            </div>
            <div className="fm-env-metric">
              <div className="fm-env-metric-icon" style={{ color: "#f59e0b" }}><FiWind size={16}/></div>
              <div>
                <div className="fm-env-metric-val">{z.pm25} µg/m³</div>
                <div className="fm-env-metric-lbl">PM2.5</div>
              </div>
              <MiniBar value={z.pm25} max={80} color={z.pm25 > 35 ? "#ef4444" : z.pm25 > 15 ? "#f59e0b" : "#10b981"} />
            </div>
            <div className="fm-env-metric">
              <div className="fm-env-metric-icon" style={{ color: "#6b7280" }}><FiWind size={16}/></div>
              <div>
                <div className="fm-env-metric-val">{z.pm10} µg/m³</div>
                <div className="fm-env-metric-lbl">PM10</div>
              </div>
              <MiniBar value={z.pm10} max={120} color={z.pm10 > 60 ? "#ef4444" : z.pm10 > 40 ? "#f59e0b" : "#10b981"} />
            </div>
            <div className="fm-env-metric">
              <div className="fm-env-metric-icon" style={{ color: "#10b981" }}><FiActivity size={16}/></div>
              <div>
                <div className="fm-env-metric-val">{z.voc} mg/m³</div>
                <div className="fm-env-metric-lbl">VOC</div>
              </div>
              <MiniBar value={z.voc} max={1} color={z.voc > 0.5 ? "#ef4444" : z.voc > 0.3 ? "#f59e0b" : "#10b981"} />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default EnvironmentPanel;
